import { render, staticRenderFns } from "./UiMediaGallery.vue?vue&type=template&id=dfbb8412&"
import script from "./UiMediaGallery.vue?vue&type=script&lang=js&"
export * from "./UiMediaGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports